export function formatTotemPrice(amount: number): string {
  // Truncate to 2 decimals to prevent rounding up, and force 2 decimal display
  const truncatedAmount = Math.trunc(amount * 100) / 100;
  const hasDecimals = truncatedAmount % 1 !== 0;
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(truncatedAmount);
}

export function calculateCartItemTotal(item: {
  unitPrice: number;
  quantity: number;
  subselections: { price: number; quantity: number }[];
}): number {
  const subselectionTotal = item.subselections.reduce((sum, sub) => sum + sub.price * sub.quantity, 0);
  return (item.unitPrice + subselectionTotal) * item.quantity;
}
